
export default {

  // 通常
  '/': {
    tag: 'page-index',
  },
  '/bio': {
    tag: 'page-bio',
  },
  '/works': {
    tag: 'page-works',
  },
  '/gallery': {
    tag: 'page-gallery',
  },
  '/contact': {
    tag: 'page-contact',
  },

};
